export function getFormFieldKey(formId: number, fieldId: string) {
  return `${formId}:${fieldId}`;
}
